import { defineMessages } from 'react-intl';

export const TrackType = Object.freeze({
  TRACK: 'Track',
  ARTIST_MESSAGE: 'ArtistMessage',
  VOICE_TRACK: 'VoiceTrack',
  AUDIO_INTRO_MESSAGE: 'IntroductoryMessage',
  AUDIO_STREAM_WARNING: 'AudioStreamWarning',
  AUDIO_WARNING: 'AudioWarning',
  CUSTOM_TRACK: 'CustomTrack',
  STATION_IDENTIFIER: 'StationIdentifier',
  AUDIO_AD: 'AUDIO_AD',
  PODCAST_EPISODE: 'PodcastEpisode',
});

export const VoiceTrackAuthorType = Object.freeze({
  ARTIST: 'AR',
  CURATOR: 'CU',
});

export const messages = defineMessages({
  messageFrom: {
    id: 't.messageFrom',
    defaultMessage: 'Message From',
  },
  flagMessage: {
    id: 't.flagMessage',
    defaultMessage: 'Flag this message as inappropriate',
  },
  featuredTrack: {
    id: 't.featuredTrack',
    defaultMessage: 'FEATURED TRACK',
  },
  viewSessionHistory: {
    id: 't.viewSessionHistory',
    defaultMessage: 'View Session History',
  },
  learnMore: {
    id: 't.learnMore',
    defaultMessage: 'Learn More',
  },
});
